import goTo from 'vuetify/lib/services/goto'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'
import Translatable from '@/app-core/mixins/translatable'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import {getContrastColor} from '@/app-core/lib/utils/color'

export default {
  name      : 'TagCatalogToolbar',
  components: {},
  directives: {},
  mixins    : [Translatable, StoreCommon],
  props     : {},
  dataStore : {
    TagMenu: 'Tag.Menu',
    TagInfo: 'Tag.Info'
  },
  data() {
    return {
      scrolling  : false,
      selectedTab: null
    }
  },
  computed: {
    TagMenuStores() {
      const activeTagId = this.$route.params?.id || null
      const tag = this.TagMenu[activeTagId]

      return tag || []
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on('store:select', this.onStoreSelect)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('store:select', this.onStoreSelect)
  },
  destroyed() {
  },
  methods: {
    getContrastColor,
    toLocaleUpperCase,
    onSelectTagClick() {
      this.$bus.$emit('show:select-tag')
    },

    onStoreClick(store) {
      this.scrolling = true

      goTo(`#tab-${this.getTranslatedField(this.getStoreById(store.StoreId), 'Slug')}`, {
        offset  : 65,
        duration: 500
      }).then(() => {
        setTimeout(() => {
          this.scrolling = false
        }, 100)
      })
    },

    onStoreSelect(tabId) {
      if (this.scrolling) return

      this.selectedTab = tabId
    },

    isTabSelected(store) {
      const tabId = `tab-${this.getTranslatedField(this.getStoreById(store.StoreId), 'Slug')}`
      return this.selectedTab === tabId
    }
  }
}
